import { Controller } from '@hotwired/stimulus';

// Keeps only one <details> accordion open at a time within this scope.
// Attach with data-controller="exclusive-accordion" on a wrapper element.
export default class extends Controller {
  connect() {
    this.details = Array.from(this.element.querySelectorAll('details'));
    this.boundOnToggle = this.#onToggle.bind(this);
    this.details.forEach((el) => el.addEventListener('toggle', this.boundOnToggle));
  }

  disconnect() {
    this.details.forEach((el) => el.removeEventListener('toggle', this.boundOnToggle));
  }

  #onToggle(event) {
    const opened = event.target;
    // Only react when a section is opened; closing sets open=false and is ignored,
    // so programmatically closing others cannot cause an event loop.
    if (!opened.open) return;

    this.details.forEach((el) => {
      if (el !== opened) el.open = false;
    });
  }
}
